// extracted by mini-css-extract-plugin
export default {"main":"CreateNews_main__QrwoA","topMain":"CreateNews_topMain__odlUF","topMainTitle":"CreateNews_topMainTitle__aKeYs","bodyMain":"CreateNews_bodyMain__tmusF"};